import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuModifierGroupSelectionOption extends BaseFormModel<MenuModifierGroupSelectionOption> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
}
